import { useEffect, useState } from "react";
import useCategories from "../hooks/useCategories";

const CategoriesSelect = ({ data, setData, name, defaultValue }) => {

    const [currentValue, setCurrentValue] = useState(null);

    const [currentCategories, setCurrentCategories] = useState([]);

    const [categoriesFilters, setCategoriesFilters] = useState({
        path: '',
        page: 1,
        orderBy: 'path,ASC',
        perPage: 10
    });

    const [{ categories, numberOfPages: categoriesNumberOfPages, loading: loadingCategories }] = useCategories({ params: categoriesFilters }, { useCache: false });

    useEffect(() => {
        if (defaultValue) {
            setCurrentValue(defaultValue);
        }
    }, [defaultValue])

    useEffect(() => {
        setCurrentCategories((old) => [...old, ...categories]);
    }, [categories])

    const handleCategory = (category) => {
        setCurrentValue(category);
        setData(old => ({ ...old, [name]: category?.id }))
    }

    return (
        <div className="col-md-12 mb-3">
            <div className="row align-items-center mb-1">
                <div className="col-md-6">
                    <label className="fw-bold mb-0 text-black">
                        Categoría
                    </label>
                    <p className="text-primary fw-bold mb-0">
                        <span className="text-dark">Valor actual:</span> {currentValue?.path || '--'}
                    </p>
                </div>
                <div className="col-md-6">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Buscar..."
                        value={categoriesFilters?.path}
                        onChange={(e) => {
                            setCurrentCategories([]);
                            setCategoriesFilters(old => ({ ...old, path: e.target.value, page: 1 }));
                        }}
                    />
                </div>
            </div>
            <ul className="list-group col-md-12 mb-3" style={{ maxHeight: 300, overflow: 'auto' }}>
                {
                    currentCategories?.map((category, i) => {
                        const level = category?.path?.split("->").length - 1;
                        return (
                            <li className="list-group-item py-1" key={`cateoria-opcion-${category?.id}`}>
                                <input
                                    className={`form-check-input me-1 ms-${level > 0 ? level + 1 : 0}`}
                                    type="checkbox"
                                    checked={data?.[name] == category?.id}
                                    value={category?.id}
                                    onChange={() => handleCategory(category)}
                                    id={`category-check-${category?.id}`}
                                />
                                <label
                                    className={`form-check-label ${level === 0 ? 'fw-bold text-primary' : 'fw-bold'}`}
                                    htmlFor={`category-check-${category?.id}`}
                                >
                                    {category?.path}
                                </label>
                            </li>
                        )
                    })
                }
                {
                    !loadingCategories && currentCategories?.length < 1 ?
                        <li className="list-group-item text-center">
                            No se encontrarón resultados.
                        </li>
                        :
                        null
                }
                {
                    loadingCategories ?
                        <li className="list-group-item text-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </li>
                        :
                        null
                }
                {
                    !loadingCategories && categoriesNumberOfPages > categoriesFilters?.page ?
                        <li className="list-group-item text-center">
                            <button
                                onClick={() => setCategoriesFilters((old) => ({ ...old, page: old?.page + 1 }))}
                                type="button"
                                className="btn btn-primary"
                            >
                                Cargar más
                            </button>
                        </li>
                        :
                        null
                }
            </ul>
        </div>
    )
}


export default CategoriesSelect;